/* eslint-disable max-len */

const brandNames = {
  // This object maps from product.info.brandName values, to keys on the "brands" object.
  Behr: ['BEHR DYNASTY', 'BEHR MARQUEE', 'BEHR ULTRA', 'BEHR PREMIUM PLUS'],
  PPG: ['SPEEDHIDE', 'PPG', 'MULTI-PRO'],
  Glidden: ['Glidden Diamond', 'Glidden Premium', 'Glidden Essentials']
};

const brands = {
  // Defines both the shape and content of the brand modal.
  Behr: {
    'Interior Paint': [
      {
        name: 'Behr Dynasty',
        image: 'https://assets.thdstatic.com/images/v1/brand-logos/behr-dynasty-blk.svg',
        Performance: 'Premium',
        Coverage: '1 Coat',
        Durability: 5,
        'Mold/Mildew Resistant': 5,
        'Resists Fading, Cracking, and Peeling': 5,
        'Odor & VOC Content': 'Low Odor/Low VOC'
      },
      {
        name: 'Behr Marquee',
        image: 'https://assets.thdstatic.com/images/v1/brand-logos/behr-marquee-black.svg',
        Performance: 'Best',
        Coverage: '1 Coat',
        Durability: 4,
        'Mold/Mildew Resistant': 4,
        'Resists Fading, Cracking, and Peeling': 4,
        'Odor & VOC Content': 'Low Odor/Low VOC'
      },
      {
        name: 'Behr Ultra',
        image: 'https://assets.thdstatic.com/images/v1/brand-logos/behr-ultra-blk.svg',
        Performance: 'Better',
        Coverage: '2 Coats',
        Durability: 4,
        'Mold/Mildew Resistant': 3,
        'Resists Fading, Cracking, and Peeling': 3,
        'Odor & VOC Content': 'Low Odor/Low VOC'
      },
      {
        name: 'Behr Premium Plus',
        image: 'https://assets.thdstatic.com/images/v1/brand-logos/behr-premium-plus-black.svg',
        Performance: 'Good',
        Coverage: '2 Coats',
        Durability: 3,
        'Mold/Mildew Resistant': 2,
        'Resists Fading, Cracking, and Peeling': 0,
        'Odor & VOC Content': 'Low Odor/Zero VOC*'
      }
    ],
    'Exterior Paint': [
      {
        name: 'Behr Marquee',
        image: 'https://assets.thdstatic.com/images/v1/brand-logos/behr-marquee-black.svg',
        Performance: 'Best',
        Coverage: '2 Coats',
        Durability: 4,
        'Mold/Mildew Resistant': 4,
        'Resists Fading, Cracking, and Peeling': 'Yes'
      },
      {
        name: 'Behr Ultra',
        image: 'https://assets.thdstatic.com/images/v1/brand-logos/behr-ultra-blk.svg',
        Performance: 'Better',
        Coverage: '2 Coats',
        Durability: 2,
        'Mold/Mildew Resistant': 4,
        'Resists Fading, Cracking, and Peeling': 'No'
      },
      {
        name: 'Behr Premium Plus',
        image: 'https://assets.thdstatic.com/images/v1/brand-logos/behr-premium-plus-black.svg',
        Performance: 'Good',
        Coverage: '2 Coats',
        Durability: 1,
        'Mold/Mildew Resistant': 1,
        'Resists Fading, Cracking, and Peeling': 'No'
      }
    ],
    disclaimers: [
      'Colorants added to this base may increase VOC level significantly depending on color choices.'
    ]
  },
  Glidden: {
    'Interior Paint': [
      {
        name: 'Glidden Diamond',
        image: 'https://assets.thdstatic.com/images/v1/brand-logos/glidden-diamond.svg',
        Performance: 'Best',
        Coverage: '1 Coat',
        'Coverage Per Gallon': '300-400 sq ft.',
        Durability: 'Outstanding',
        'Easy To Clean': 'Outstanding',
        'Stain Blocking': 'Exceptional',
        'Odor & VOC Content': 'Low Odor/Zero VOC*'
      },
      {
        name: 'Glidden Premium',
        image: 'https://assets.thdstatic.com/images/v1/brand-logos/glidden-premium.svg',
        Performance: 'Better',
        Coverage: '2 Coats',
        'Coverage Per Gallon': '300-400 sq ft.',
        Durability: 'Scrubbable',
        'Easy To Clean': 'Washable',
        'Stain Blocking': 'Outstanding',
        'Odor & VOC Content': 'Low Odor/Zero VOC*'
      },
      {
        name: 'Glidden Essentials',
        image: 'https://assets.thdstatic.com/images/v1/brand-logos/glidden-essentials.svg',
        Performance: 'Good',
        Coverage: 'Primer Plus 2 Coats',
        'Coverage Per Gallon': '300-400 sq ft.',
        Durability: 'Scrubbable',
        'Easy To Clean': 'Washable',
        'Stain Blocking': 'Good',
        'Odor & VOC Content': 'Low Odor/Low VOC'
      }
    ],
    'Exterior Paint': [
      {
        name: 'Glidden Premium',
        image: 'https://assets.thdstatic.com/images/v1/brand-logos/glidden-premium.svg',
        Performance: 'Better',
        Coverage: '2 Coats',
        'Coverage Per Gallon': '300-400 sq ft.',
        Durability: 'Outstanding',
        'Mold/Mildew Resistant': 'Outstanding',
        'Resists Fading, Cracking, and Peeling': 'Outstanding'
      },
      {
        name: 'Glidden Essentials',
        image: 'https://assets.thdstatic.com/images/v1/brand-logos/glidden-essentials.svg',
        Performance: 'Good',
        Coverage: 'Primer Plus 2 Coats',
        'Coverage Per Gallon': '300-400 sq ft.',
        Durability: 'Good',
        'Mold/Mildew Resistant': 'Good',
        'Resists Fading, Cracking, and Peeling': 'Good'
      }
    ],
    disclaimers: [
      'Colorants added to this base may increase VOC level significantly depending on color choices.'
    ]
  },
  PPG: {
    'Interior Paint': [
      {
        name: 'MULTI-PRO',
        image: 'https://assets.thdstatic.com/images/v1/paintReorder/ppg-logo-config-panel.svg',
        showName: true,
        Performance: 'Best',
        Coats: '2 Coats*',
        'Coverage Per Gallon': 'Approx. 400 sq. ft.',
        Durability: 'Good',
        'Touch Up': 'Good',
        'Dry To Touch': '30 min.',
        'VOC Content': 'Low',
        Odor: 'Low'
      },
      {
        name: 'PRO EV ZERO',
        image: 'https://assets.thdstatic.com/images/v1/paintReorder/ppg-logo-config-panel.svg',
        showName: true,
        Performance: 'Better',
        Coats: '2 Coats*',
        'Coverage Per Gallon': 'Approx. 400 sq. ft.',
        Durability: 'Good',
        'Touch Up': 'Good',
        'Dry To Touch': '1 hr.',
        'VOC Content': 'Zero',
        Odor: 'Low'
      },
      {
        name: 'SPEEDHIDE',
        image: 'https://assets.thdstatic.com/images/v1/paintReorder/ppg-logo-config-panel.svg',
        showName: true,
        Performance: 'Good',
        Coats: '2 Coats*',
        'Coverage Per Gallon': 'Approx. 400 sq. ft.',
        Durability: 'Better',
        'Touch Up': 'Great',
        'Dry To Touch': '30 min.',
        'VOC Content': 'Low',
        Odor: 'Low'
      }
    ],
    'Exterior Paint': [
      {
        name: 'SPEEDHIDE',
        image: 'https://assets.thdstatic.com/images/v1/paintReorder/ppg-logo-config-panel.svg',
        showName: true,
        Performance: 'Better',
        Coats: '2 Coats*',
        'Coverage Per Gallon': 'Approx. 400 sq. ft.',
        Durability: 'Better',
        'Mold/Mildew Resistant': 'Yes',
        'Resists Fading, Cracking, and Peeling': 'Yes'
      },
    ],
    disclaimers: [
      'Separate primer or multiple coats may be required.',
      'Colorants added to this base may increase VOC level significantly depending on color choices.'
    ]
  }
};

const sheens = [
  {
    name: 'Flat/Matte',
    image: 'https://assets.thdstatic.com/images/v1/paint/flat-matte-tile.png',
    washability: 1,
    finishPerformance: 'Low sheen, non-reflective appearance',
    bestUses: 'Low Traffic Areas',
    bestSuitedLocations: [
      'Living Rooms',
      'Dining Rooms',
      'Ceilings',
      'Bedrooms'
    ]
  },
  {
    name: 'Eggshell',
    image: 'https://assets.thdstatic.com/images/v1/paint/eggshell-tile.png',
    washability: 2,
    finishPerformance: 'Soft, velvety appearance',
    bestUses: 'Moderate Traffic Areas',
    bestSuitedLocations: [
      'Living Rooms',
      'Dining Rooms',
      'Hallways',
      'Family Room'
    ]
  },
  {
    name: 'Satin',
    image: 'https://assets.thdstatic.com/images/v1/paint/satin-tile.png',
    washability: 3,
    finishPerformance: 'Soft, pearl-like appearance',
    bestUses: 'High Traffic Areas',
    bestSuitedLocations: [
      'All Interior Spaces',
      'Kitchen',
      'Bathrooms',
      'Kid\'s Rooms'
    ]
  },
  {
    name: 'Semi-Gloss',
    image: 'https://assets.thdstatic.com/images/v1/paint/semi-gloss-tile.png',
    washability: 4,
    finishPerformance: 'Soft, pearl-like appearance',
    bestUses: 'High Traffic Areas',
    bestSuitedLocations: [
      'Bathrooms',
      'Doors & Windows',
      'Trim',
      'Cabinets'
    ]
  },
  {
    name: 'High-Gloss',
    image: 'https://assets.thdstatic.com/images/v1/paint/high-gloss-tile.png',
    washability: 4,
    finishPerformance: 'Brilliant, shiny appearance',
    bestUses: 'Very High Traffic Areas',
    bestSuitedLocations: [
      'Doors & Windows',
      'Trim',
      'Cabinets',
      'Shutters'
    ]
  }
];

const paintTypes = {
  description: 'Different paints have different properties, and are formulated for different purposes. Interior paint is made to be scrubbed, resist staining, and allow cleaning. Exterior paints are made to combat fading and mildew.',
  types: [
    {
      imageUrl: 'https://assets.thdstatic.com/images/v1/paint/paint-type-interior.svg',
      paintType: 'Interior',
      options: [
        'Resist stains, and is easy to clean',
        'Lower odor, more suitable for indoor projects'
      ]
    },
    {
      imageUrl: 'https://assets.thdstatic.com/images/v1/paint/paint-type-exterior.svg',
      paintType: 'Exterior',
      options: [
        'Fading and mildew resistant',
        'Resist peeling, chipping, and fading due to sunlight'
      ]
    }
  ]
};

const calculateSize = {
  disclaimer: 'These calculations are a rough estimate allowing for one coat of paint. They do NOT account for ceiling or trim. Precise paint needs will vary according to many factors, including application method.',
  estimatesPerRoom: [
    {
      name: 'Small Room',
      image: 'https://assets.thdstatic.com/images/v1/paint/small-room-illustration.svg',
      roomSize: '1 - 400',
      amountNeeded: '1 Gallon'
    },
    {
      name: 'Medium Room',
      image: 'https://assets.thdstatic.com/images/v1/paint/medium-room-illustration.svg',
      roomSize: '401 - 1,600',
      amountNeeded: '2 - 4 Gallons'
    },
    {
      name: 'Large Room',
      image: 'https://assets.thdstatic.com/images/v1/paint/large-room-illustration.svg',
      roomSize: '1,601 - 3,200',
      amountNeeded: '4 - 8 Gallons'
    }
  ]
};

const arrowConfig = {
  WIDTH: 60,
  HEIGHT: 30,
  GRADIENT_HEIGHT: 30,
  LEFT_COLOR: '#00000005',
  RIGHT_COLOR: '#000000a6',
  BACKGROUND: '#666'
};

export {
  brandNames,
  brands,
  sheens,
  paintTypes,
  calculateSize,
  arrowConfig
};
